<template>
	<p-section-content-grid>
		<div slot="left">
			<div class="tw-mb-3">
				<guideline-job-form
					@jobAdded="onJobNameAdded"
					:job-list="jobList"
					:max-jobs-list="-1"
					:groups="groups"
					:area-filter="selectedAreaId"
					@area-filter-change="onAreaFilterChange"
				/>
			</div>
			<div>
				<guideline-job-list
					:job-list="displayedJobList"
					:selected-job="selectedJob"
					:groups="groups"
					@deleteClick="onDeleteClick"
					@editionClick="onEditionClick"
				/>
			</div>
		</div>
		<div slot="right">
			<guideline-job-selector
				v-show="jobIsSelected"
				:selected-prev="selectedPrev"
				:selected-next="selectedNext"
				:selected-job="selectedJob"
				@selectedJobDataChanged="onSelectedJobDataChanged"
				@prevClick="onPrevClick"
				@nextClick="onNextClick"
				@infoClick="onInfoClick"
				:job-list-navigation="true"
				:show-info-icon="true"
				ref="jobSelector"
			>
				<template slot="action-footer">
					<v-btn
						:disabled="!selectionIsReady"
						class="custom-button tw-px-8"
						color="primary"
						@click="onGenerateHierarchyClick"
						>Asignar Jerarquía</v-btn
					>
					<p v-if="!selectionIsReady" class="tw-mt-2 tw-mb-0">
						Configura al menos un puesto de trabajo para continuar
					</p>
				</template>
			</guideline-job-selector>
			<guideline-model-instructions
				v-show="!jobIsSelected"
				:disabled="!selectionIsReady"
				@generate-hierarchy-click="onGenerateHierarchyClick"
			/>
		</div>
	</p-section-content-grid>
</template>

<script>
import GuidelineJobForm from '@/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/guideline-job-form';
import GuidelineJobList from '@/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/job-list/guideline-job-list';
import GuidelineModelInstructions from '@/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/guideline-model-instructions';
import {
	filter,
	isEmpty,
	findIndex,
	propEq,
	prop,
	isNil,
	pathOr,
	any,
	clone,
} from 'ramda';
import GuidelineJobSelector from '@/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/guideline-job-selector';
import { mapState } from 'vuex';
import { generateJob, verifyJobIsCompleted } from '../../../helpers/helpers';
import PSectionContentGrid from '../../../../shared/components/ui/p-section-content-grid';

export default {
	name: 'page-supply-guideline-model',
	components: {
		PSectionContentGrid,
		GuidelineJobSelector,
		GuidelineModelInstructions,
		GuidelineJobList,
		GuidelineJobForm,
	},
	computed: {
		...mapState('jobEvaluation', {
			jobList: pathOr(
				[],
				['supplies', 'guidelineModel', 'userForm', 'jobList'],
			),
			groups: pathOr([], ['supplies', 'guidelineModel', 'groups']),
		}),
		displayedJobList() {
			if (!this.selectedAreaId) return this.jobList;
			return filter(
				job => job.areaId === this.selectedAreaId,
				this.jobList,
			);
		},
		navigableList() {
			const areaNames = {};
			(this.groups || []).forEach((g) => {
				areaNames[g.id] = g.name;
			});
			const jobsWithArea = this.displayedJobList.map(job => ({
				...job,
				sortAreaName: areaNames[job.areaId] || 'Sin área',
			}));
			return jobsWithArea.sort((a, b) => {
				const areaDiff = a.sortAreaName.localeCompare(b.sortAreaName);
				return areaDiff !== 0 ? areaDiff : a.name.localeCompare(b.name);
			});
		},
		jobIsSelected() {
			return !isEmpty(this.selectedJob);
		},
		selectedIndex() {
			return findIndex(propEq('name', this.selectedJob.name), this.navigableList);
		},
		selectedNext() {
			return prop(this.selectedIndex + 1, this.navigableList);
		},
		selectedPrev() {
			return this.selectedIndex - 1 > -1
				? prop(this.selectedIndex - 1, this.navigableList)
				: undefined;
		},
		selectionIsReady() {
			return any(propEq('completed', true), this.jobList);
		},
	},
	data() {
		return {
			selectedJob: {},
			selectedAreaId: null,
		};
	},
	created() {
		this.$store.dispatch('jobEvaluation/loadGroups');
	},
	methods: {
		onAreaFilterChange(areaId) {
			this.selectedAreaId = areaId;
		},
		onJobNameAdded(jobName) {
			this.$store.dispatch('jobEvaluation/updateJobList', [
				...this.jobList,
				generateJob(jobName),
			]);
		},
		onDeleteClick(selectedJob) {
			const jobList = filter(
				job => job.name !== selectedJob.name,
				this.jobList,
			);
			this.$store.dispatch('jobEvaluation/updateJobList', jobList);
		},
		onEditionClick(selectedJob) {
			this.selectedJob = selectedJob;
			this.$refs.jobSelector.prevLocalPage();
		},
		onInfoClick() {
			this.selectedJob = {};
		},
		onNextClick() {
			if (!isNil(this.selectedNext)) {
				this.selectedJob = this.selectedNext;
			}
		},
		onPrevClick() {
			if (!isNil(this.selectedPrev)) {
				this.selectedJob = this.selectedPrev;
			}
		},
		onSelectedJobDataChanged(job) {
			const modifiedJob = clone(job);
			modifiedJob.completed = verifyJobIsCompleted(job);
			this.selectedJob = modifiedJob;
			this.$store.dispatch('jobEvaluation/updateJobItem', modifiedJob);
		},
		onGenerateHierarchyClick() {
			this.$store
				.dispatch('jobEvaluation/assignHierarchy', { onlyCompleted: true })
				.then(() => {
					const options = {};
					if (this.selectedAreaId) {
						options.query = { areaId: this.selectedAreaId };
					}
					this.goTo('job-supply-guideline-model-hierarchy', options);
				})
				.catch(error => console.error(error));
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/modules/job-evaluation/pages/supplies/guideline-model/page-supply-guideline-model.vue